<template>
  <div class="min-h-screen relative bg-black text-white grid md:grid-cols-2">
    <!-- Imagem lateral no desktop -->
    <div class="hidden md:flex items-center justify-center relative">
      <img
        src="/cashbroker-bg.png"
        alt="Cash Broker Background"
        class="absolute inset-0 w-full h-full object-cover"
      />
      <div class="z-10 text-center">
        <h1 class="text-8xl font-bold text-white drop-shadow-lg">Cash</h1>
        <h2
          class="text-4xl font-semibold text-orange-500 tracking-widest mt-2 drop-shadow-lg"
        >
          BROKER
        </h2>
      </div>
    </div>

    <div class="fixed inset-0 z-0 md:hidden">
      <img
        src="/cashbroker-bg.png"
        alt="Cash Broker Background Mobile"
        class="w-full h-full object-cover"
      />
    </div>

    <!-- Card de login (melhorado) -->
    <div
      class="flex items-center justify-center p-6 md:bg-[#0f0f0f] relative z-10"
    >
      <div
        class="w-full max-w-md bg-[#1a1a1a] border border-gray-700 p-8 rounded-xl shadow-md"
      >
        <!-- Logo -->
        <div class="flex items-center justify-center gap-4 mb-8">
          <img src="/image/logo.png" alt="Logo" class="h-16 w-auto" />
          <div class="leading-tight">
            <h1 class="text-white text-3xl font-bold">Cash</h1>
            <h2 class="text-orange-500 text-xl font-semibold tracking-widest">
              BROKER
            </h2>
          </div>
        </div>

        <!-- Título -->
        <h2 class="text-white text-xl font-semibold text-center mb-6">
          Acesse sua conta
        </h2>

        <!-- Formulário -->
        <form class="space-y-4" @submit.prevent="handleSubmit">
          <div>
            <label class="text-sm text-gray-300 block mb-1">E-mail</label>
            <input
              v-model="userForm.email"
              type="email"
              placeholder="seu@email.com"
              class="w-full px-4 py-3 rounded-md bg-black/60 text-white placeholder-gray-500 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>

          <div>
            <label class="text-sm text-gray-300 block mb-1">Senha</label>
            <input
              v-model="userForm.password"
              type="password"
              placeholder="Digite sua senha"
              class="w-full px-4 py-3 rounded-md bg-black/60 text-white placeholder-gray-500 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
            <div class="text-right mt-2">
              <RouterLink
                to="/auth/recover-password"
                class="text-sm text-orange-400 hover:underline"
              >
                Esqueceu a senha?
              </RouterLink>
            </div>
          </div>

          <button
            type="submit"
            class="w-full py-3 mt-2 rounded-md bg-gradient-to-r from-orange-600 to-red-600 hover:opacity-90 transition font-semibold"
          >
            <span v-if="auth.isLoading">Aguarde...</span>
            <span v-else>Entrar</span>
          </button>

          <p v-if="auth.error" class="text-red-400 text-sm text-center mt-2">
            {{ auth.error }}
          </p>
        </form>

        <!-- Link de registro -->
        <div class="text-center mt-6">
          <RouterLink
            to="/auth/register"
            class="text-sm text-gray-400 hover:text-orange-400 transition"
          >
            Não possui conta? <span class="underline">Cadastre-se</span>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";
import { onMounted, ref } from "vue";
import { create } from "@bufbuild/protobuf";
import { LoginRequestSchema } from "@/gen/api/v1/auth_pb";

const auth = useAuthStore();
const userForm = ref({
  email: "",
  password: "",
});

const handleSubmit = async () => {
  if (!userForm.value.email || !userForm.value.password) {
    auth.error = "Preencha todos os campos.";
    return;
  }

  const response = await auth.login(
    create(LoginRequestSchema, {
      email: userForm.value.email,
      password: userForm.value.password,
    }),
  );

  console.log(response);
};

onMounted(() => {
  auth.error = "";
});
</script>
